export const homeObjOne = {
    id: 'aboutus',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Welcome to Structural Connections',
    headline: 'Building Your Team, Building Your Success',
    description: 'We are a new recruitment company dedicated to connecting exceptional professionals with top-notch organisations in the construction and engineering industry. Our team of experienced recruiters has a deep understanding of the industry, and we work closely with clients to identify and attract the best talent. Contact us today to learn more.',
    imgStart: false,
    img: require('../../images/desktop_remote.png'),
    alt: 'Desktop',
    dark: true,
    primary: true,
    darkText: false
};

export const homeObjTwo = {
    id: 'ourclients',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'our clients',
    headline: 'Revolutionising Recruitment: Our Impressive Roster of Clients Speaks for Itself',
    description: 'Structural Connections offers top-notch recruitment solutions to leading companies in the UK. Our extensive nationwide database of skilled professionals and consultants in engineering enables us to provide unparalleled expertise to clients across all industries. Our services are trusted to consistently deliver exceptional results.',
    buttonLabel: 'Learn More',
    imgStart: false,
    img: require('../../images/standing_woman.png'),
    alt: 'Standing Woman',
    dark: false,
    primary: false,
    darkText: true
};